import classes from './CargoTypesSection.module.sass'
import {
  CargoItemInterface,
  SlotItemInterface,
  TransportItemInterface,
} from '../../types/interfaces'
import { cargoTypes } from '../../utils/constants'

type Props = {
  item: TransportItemInterface | SlotItemInterface | CargoItemInterface
}

export const CargoTypesSection = ({ item }: Props) => {
  return (
    <div className={classes.Container}>
      {item.cargo_types.map((el) => `${cargoTypes.find((item) => item.id === el)?.name} `)}
    </div>
  )
}
  